// extracted by mini-css-extract-plugin
export default {"major-currencies":"finance_currencies_major-currencies","clearfix":"finance_currencies_clearfix","row":"finance_currencies_row","flag":"finance_currencies_flag"};